import React, {useState} from "react";
import styles from './PlusMinus.module.scss';
import AddCircleOutlineRoundedIcon from '@material-ui/icons/AddCircleOutlineRounded';
import RemoveCircleOutlineRoundedIcon from '@material-ui/icons/RemoveCircleOutlineRounded';

export interface IFormikSearchSelectorProps {
  min?: number;
  max?: number;
  setCount?: (count: number) => void;
}

const PlusMinus = (props: IFormikSearchSelectorProps) => {
  const [count, setCount] = useState(props.min);
  const _setCount = (count) => {
    setCount(count);
    props.setCount(count);
  };
  return (
    <span className={styles.PlusMinus}>
      <AddCircleOutlineRoundedIcon onClick={() => _setCount(((count + 1) > props.max) ? count : (count + 1))}/>
      <span className={styles.value}>{count}</span>
      <RemoveCircleOutlineRoundedIcon onClick={() => _setCount(((count - 1) < props.min) ? count : (count - 1))}/>
    </span>
  );
};

PlusMinus.defaultProps = {
  min: 1,
  max: 99,
  setCount: () => {
  },
};

export default PlusMinus;
